import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import ru from './ru.json';

const TG_LANG = (() => {
  const w = typeof window !== 'undefined' ? window : undefined;
  return w?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code ?? null;
})();

// An explicit in-app language choice (localStorage `polybot.lang`) must
// win over the Telegram client language — otherwise switching the app
// language is undone on every reload. The Telegram language is just a
// first-run default, so it's registered as a detector ordered *after*
// localStorage. A hardcoded `lng` here would shadow the detector
// entirely and revert the user's saved choice.
const detector = new LanguageDetector();
detector.addDetector({
  name: 'telegram',
  lookup: () => (TG_LANG === 'ru' ? 'ru' : undefined),
});

void i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'telegram', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'polybot.lang',
    },
  });

export { i18n };
